// src/components/NavBars/BottomNav.tsx
import {
  HomeIcon,
  MagnifyingGlassIcon,
  ShoppingCartIcon,
  UserIcon,
} from '@heroicons/react/24/outline';
import { useNotifications } from '../../context/NotificationContext';
import { IoCalendarNumberOutline } from 'react-icons/io5';
import { useLocation } from 'react-router-dom';

type BottomNavProps = {
  currentTab: string;
  onNavigate: (path: string) => void;
};

export default function BottomNav({ currentTab, onNavigate }: BottomNavProps) {
  const { unreadCount, isLoading } = useNotifications();
  const location = useLocation();

  // if we're anywhere under /app/onboarding, disable nav
  const inOnboarding = location.pathname.startsWith('/app/onboarding');

  const tabs = [
    { key: 'home',        Icon: HomeIcon,               path: '/app/home' },
    { key: 'search',      Icon: MagnifyingGlassIcon,    path: '/app/search' },
    { key: 'mealplan',    Icon: IoCalendarNumberOutline, path: '/app/meal-plan' },
    { key: 'shoppinglist',Icon: ShoppingCartIcon,        path: '/app/shopping-list' },
    { key: 'profile',     Icon: UserIcon,               path: '/app/profile' },
  ];

  return (
    <nav
      className="
        fixed left-0 right-0 bottom-0
        border-t border-gray-200
        z-[9999] bg-black text-gray-100 overflow-hidden
      "
      // total height = base + device safe-area (iOS adds, Android ~ 0)
      style={{ height: 'calc(var(--nav-height-base) + var(--safe-bottom))' }}
    >
      {/* anchor icons to the bottom; safe-area leaves finger room */}
      <div
        className="flex justify-around items-end h-full"
        style={{ paddingBottom: 'calc(var(--safe-bottom) + var(--icon-bottom-extra))' }}
      >
        {tabs.map(({ key, Icon, path }) => {
          const isActive = currentTab === key;
          return (
            <button
              key={key}
              id={`nav-${key}`}
              onClick={() => {
                if (!inOnboarding) onNavigate(path);
              }}
              aria-label={key}
              disabled={inOnboarding}
              className={`
                relative flex items-center justify-center
                w-10 h-10
                transition-colors
                ${isActive
                  ? 'bg-brandPurpleLight text-brandPurpleDark'
                  : 'text-gray-200 hover:text-white'}
                rounded-full
                ${inOnboarding ? 'cursor-not-allowed opacity-60' : ''}
              `}
            >
              <Icon className="w-6 h-6" />
              {key === 'profile' && !isLoading && unreadCount > 0 && (
                <span
                  className="
                    absolute -top-1 -right-1
                    w-3 h-3 bg-red-500 rounded-full
                    border-2 border-cream
                  "
                />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
